import { Td, Tr } from '@chakra-ui/react';
import React from 'react';
import { DateFormatMDY } from 'utils';

interface Props {
  vendorData: any;
  index: number;
}
const VendorListItemReport: React.FC<Props> = (props) => {
  const { vendorData, index } = props;

  return (
    <Tr key={vendorData.id}>
      <Td>{index}</Td>
      <Td>{vendorData?.company}</Td>
      <Td>{DateFormatMDY(vendorData?.date_added) || '-'}</Td>
      <Td>{DateFormatMDY(vendorData?.date_removed) || '-'}</Td>
      <Td>{vendorData?.location || '-'}</Td>
      <Td isNumeric>{vendorData?.number_of_jobs}</Td>
      <Td isNumeric>{vendorData?.total_hours_worked}</Td>
      <Td isNumeric>{vendorData?.total_workers}</Td>
    </Tr>
  );
};

export default VendorListItemReport;
